import React, { useState } from 'react';
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import Label from 'components/general/Label';
import Noc from "components/presentation/Noc";
import Discipline from "components/presentation/Discipline";
import Moment from "react-moment";
import { DIR_MEDIA_TYPE, getFullPath, usePathFlag, } from "helpers/utils";
import { Stack } from 'react-bootstrap';
import useViewport from 'components/general/useViewPort';


export default function HorseInfo({ data }) {
    const { breakPoint } = useViewport();
    const isMobile = (breakPoint === "sm" || breakPoint === "xs")
    const params = useUrlFriendlyToParameters()
    let paramsURL = { ...params }
    const horseCode = paramsURL['mirs_code'];
    const [showImage, setShowImage] = useState(true);
    const srcFlag = usePathFlag(data?.horse?.organisation?.code)
    const hideImg = () => {
        setShowImage(false);
    }
    // let fullPath = `${process.env.REACT_APP_SERVER_URL_RESOURCES}/pic/${mirs_competition}/HORSE/${horseCode}.png`;
    //fullPath = "https://mnt-mt-grs20d.wpd.mev.atos.net/pic/OG2024/HORSE/H100225.png";
    return (
        <>
            {data && data?.horse && data?.horse?.code &&
                <div className="container-fluid mb-2">
                    <Stack direction={isMobile ? 'vertical' : 'horizontal'}>
                        <div>
                            <picture>
                                {showImage && data?.horse?.image ? (
                                    <img className="wrsBiosDetail__image" alt={data?.horse?.name} 
                                    src={getFullPath(horseCode, DIR_MEDIA_TYPE.HORSE, data?.horse?.image?.imageExtension)} 
                                    onError={() => hideImg()} />
                                ) : ''}
                            </picture>
                        </div>
                        <div style={{ marginLeft: 30 }}></div>
                        <div>
                            <div className="wrsNoc" >
                                <div className="flag">
                                    <img
                                        src={srcFlag}
                                        alt=""
                                    />
                                </div>
                                <Noc noc={data?.horse?.organisation?.code} code={data?.horse?.organisation?.description}></Noc>
                            </div>
                            {data?.horse?.discipline && <div className="wrsNoc pt-2" >
                                <Discipline code={data.horse.discipline.code} description={data.horse.discipline.description} />
                            </div>}
                            {/* {data?.horse?.discipline && <div className="pt-2" key={data.horse.discipline.code}><Discipline code={data.horse.discipline.code} description={data.horse.discipline.description} /></div>} */}
                            {data?.horse?.passport && <div className="pt-2"><b><Label data="HeaderFEIIDNum" />:&nbsp;</b> {data?.horse?.passport}</div>}
                            {data?.horse?.name && <div className="pt-2"><b><Label data="HeaderHorseName" />:&nbsp;</b> {data?.horse?.name}</div>}
                            {data?.horse?.yearBirth && <div className="pt-2"><b><Label data="LabelYearOfBirth" />:&nbsp;</b> <Moment parse="YYYY-MM-DD" format="YYYY">{data?.horse?.yearBirth}</Moment></div>}
                            {data?.horse?.owner && <div className="pt-2"><b><Label data="Owner" />:&nbsp;</b> {data?.horse?.owner}</div>}
                            {data?.horse?.sex?.description && <div className="pt-2"><b><Label data="HeaderSex" />:&nbsp;</b> {data?.horse?.sex?.description}</div>}
                            {data?.horse?.secondOwner && <div className="pt-2"><b><Label data="HeaderSecondOwner" />:&nbsp;</b> {data?.horse?.secondOwner}</div>}
                            {data?.horse?.groom && <div className="pt-2"><b><Label data="HeaderGroom" />:&nbsp;</b> {data?.horse?.groom}</div>}
                            {data?.horse?.colour?.description && <div className="pt-2"><b><Label data="HeaderColour" />:&nbsp;</b> {data?.horse?.colour?.description}</div>}
                            {data?.horse?.breed?.description && <div className="pt-2"><b><Label data="HeaderBreed" />:&nbsp;</b> {data?.horse?.breed?.description}</div>}
                            {data?.horse?.sire && <div className="pt-2"><b><Label data="HeaderSire" />:&nbsp;</b> {data?.horse?.sire}</div>}
                        </div>
                    </Stack>
                </div>
            }
        </>
    )
}